<template>
  <div id="tablePage">
    <!-- 存货汇总 -->
    <div class="orderTable">
      <el-table
        ref="tableData"
        :data="tableData"
        :height="tableHeight"
        @sort-change="sortChange"
        v-loading="loading"
      >
        <template slot="empty" v-if="!loading">
          <div v-if="isNetWrong" class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data" style="margin-top: -15px !important; text-align: center;" @click="showData">加载失败,点击重试</div>
          </div>
          <div v-else class="no-datas">
            <div class="no-data-img">
              <img src="../../../assets/images/no_data.png" alt="" style="width: 100%;">
            </div>
            <div class="no-data">暂无数据</div>
          </div>
        </template>
        <el-table-column
          prop="warehouseId"
          label="仓单号"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="commodityName"
          label="商品名称"
          min-width="100"
        >
        </el-table-column>
        <el-table-column
          prop="pickQuantity"
          label="商品数量"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="weight"
          label="商品总重量"
          min-width="90"
        >
        </el-table-column>
        <el-table-column
          prop="name"
          label="仓库名称"
          min-width="100"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="warehouseType"
          label="仓单类型"
        >
        </el-table-column>
        <el-table-column
          prop="warehouseCode"
          label="仓单原始凭证号"
        >
        </el-table-column> -->
        <el-table-column
          prop="createTime"
          label="提货单开具日期"
          min-width="155"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.createTime | dateFormateDay }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="deliverTime"
          label="出库日期"
          min-width="155"
        >
          <template slot-scope="scope">
            <span> {{ scope.row.deliverTime | dateFormateDay }}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="pageData.total">
        <el-col :span="24" class="paginateWrap">
          <el-pagination
            class="paginationPage"
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
/*global http protocol*/
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['warehouseId', 'isSearch'],
  data() {
    return {
      tableHeight: 0,
      loading: false,
      checked: false,
      tableData: [
        // {
        //   bsFlag: 'S',
        //   closePl: 0,
        //   commodityCode: 'YH2210',
        //   commodityId: 243,
        //   commodityName: '红皮洋葱2210',
        //   createTime: 1639492292000,
        //   fee: 12.01,
        //   firmId: 5852,
        //   holdDetailId: 692573,
        //   margin: 800.6,
        //   minPriceChange: 1,
        //   ocFlag: 'O',
        //   orderId: 931868,
        //   priceScale: 0,
        //   quantity: 1,
        //   singlePrice: 4003,
        //   stampFee: 0,
        //   stampFeeRate: 0,
        //   tqTip: 0,
        //   tradeDay: 20211214,
        //   tradeId: 1273609,
        //   tradeType: 1,
        //   deliverTime: 1639492292000
        // }
      ],
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 20,
        currentPage: 1
      },
      // 表格label宽度
      tcdTableWidth: {
        bsFlag: 80,
        ocFlag: 110,
        closePl: 100
      },
      TradeListSum: {
        'bsFlag': '',
        'closePl': 0,
        'commodityCode': '',
        'commodityId': 0,
        'commodityName': '',
        'createTime': 0,
        'fee': 0,
        'firmId': 0,
        'holdDetailId': 0,
        'margin': 0,
        'ocFlag': '',
        'orderId': 0,
        'quantity': 0,
        'singlePrice': 0,
        'tqTip': 0,
        'tradeDay': 0,
        'tradeId': 0,
        'tradeType': 0,
        'deliverTime': 0,
        'stampFee': 0
      },
      isNetWrong: false
    }
  },
  computed: {
    ...mapGetters(['sessionInfoGetter'])
  },
  watch: {
    isSearch(val) {
      if (val) {
        this.pageData.currentPage = 1
        this.showData()
      }
    }
  },
  created() {
    window.onresize = () => {
      this.$nextTick(() => {
        this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      })
    }
  },
  updated() {
    this.$nextTick(() => {
      this.tableHeight = util.autoHeightTable(this.$refs.tableData.$el.offsetTop + 32)
      this.$refs['tableData'].doLayout()
    })
  },
  mounted() {
    this.showData()
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.showData()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.showData()
    },
    // 订单展示
    showData() {
      const that = this
      this.loading = true
      const params = JSON.parse(JSON.stringify(protocol.param_getPickList))
      params.data = {}
      params.data.page =
          this.pageData.currentPage - 1
      params.data.size =
          '' + this.pageData.pageSize
      params.data.firmId = this.sessionInfoGetter.firmId
      params.data.pickStatus = 'S'
      params.data.pickType = 'Z'
      params.data.warehouseId = this.warehouseId // 搜索仓单号
      http.gPost(params).then(response => {
        if (response.data.code != 0) {
          this.$message({ message: response.data.message })
          this.isNetWrong = true
        } else {
          this.isNetWrong = false
        }
        if (response.data) {
          if (response.data && response.data.code == '0') {
            this.pageData.total = response.data.value.totalElements
            const arr = response.data.value.content
            this.judgeDataType(arr)
            // this.TradeListSum = response.data.value.sumData
          }
        }
        this.loading = false
      }).catch((e) => {
        this.loading = false
        setTimeout(() => {
          that.showData()
        }, 1000)
      })

      // protocol.queryTradeListSum.data = protocol.queryUserClinches.data
      // http.gPost(protocol.queryTradeListSum).then(response => {
      //   if (response.data.code != 0) {
      //     this.$message({ message: response.data.message })
      //   }
      //   if (response.data) {
      //     if (response.data && response.data.code == '0') {
      //       this.TradeListSum = response.data.value
      //     }
      //   }
      // })
    },
    // 判断数据类型
    judgeDataType(arr) {
      const that = this
      this.each(arr, function(arrIndex) {
        arrIndex.textColor = ''
        // 判断时间
        // that.modifyTime(arrIndex, 'createTime')
        // that.modifyTime(arrIndex, 'deliverTime')
        // 判断方向
        that.modifyData(arrIndex, 'bsFlag', 'B', '买入', '卖出')
        that.modifyData(arrIndex, 'ocFlag', 'O', '订立', '转让')
        // 判断委托状态 1-已委托，2-已成交，3-已撤单，4-部分成交，5-部分成交后撤单
        // const stateList = ['已委托', '已成交', '已撤单', '部分成交', '部分成交后撤单']
        // stateList.forEach((item, index) => {
        //   that.modifyData(arrIndex, 'orderStatus', index + 1, item)
        // })
        // arrIndex.textColor = that.threeTxtColor(Number(arrIndex.closePl))
        // // 价格
      })
      this.tableData = arr
    },
    // 排序
    sortChange(column, prop, order) {
      if (column.order == 'ascending') {
        protocol.queryUserClinches.data.sort[0].direction = 'ASC'
      } else {
        protocol.queryUserClinches.data.sort[0].direction = 'DESC'
      }
      // protocol.queryUserClinches.data.firmId = this.sessionInfoGetter.firmId
      if (column.column) {
        this.eachSortChange(column.column.property)
        http.gPost(protocol.queryUserClinches).then(response => {
          if (response.data.code != 0) {
            this.$message({ message: response.data.message })
            this.isNetWrong = true
          } else {
            this.isNetWrong = false
          }
          if (response.data) {
            if (response.data && response.data.code == '0') {
              this.pageData.total = response.data.value.totalElements
              const arr = response.data.value.content
              this.judgeDataType(arr)
              this.TradeListSum = response.data.value.sumData
            }
          }
        })
      }
    },
    // 分项排序
    eachSortChange(str) {
      return (protocol.queryUserClinches.data.sort[0].property = str)
    },
    // 合计
    getSummaries(param) {
      const { columns } = param
      const sums = []
      const that = this
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 3) {
          sums[index] = '共' + this.pageData.total + '条'
          return
        }
        if (index === 7) { // 成交数量
          sums[index] = that.TradeListSum.quantity
          return
        }
        if (index === 8) { // 成交金额
          sums[index] = that.TradeListSum.funds
          return
        }
        // if (index === 10) { // 转让存货价
        //   sums[index] = that.TradeListSum.fee
        //   return
        // }
        if (index === 10) { // 利润
          sums[index] = that.TradeListSum.closePl
          return
        }
        if (index === 11) { // 印花税
          sums[index] = that.TradeListSum.stampFee
          return
        }
        if (index === 12) { // 手续费
          sums[index] = that.TradeListSum.fee
          return
        }
        sums[index] = ''
      })
      return sums
    },
    // 根据语言改变样式
    setLanguageCss() {
      // 防止清缓存后数据消失
      this.$i18n.locale = localStorage.lang || navigator.language.slice(-2).toLowerCase()
      switch (localStorage.lang) {
        case 'en': {
          const tcdTableEnWidth = {
            bsFlag: 120,
            ocFlag: 150,
            closePl: 150
          }
          localStorage.setItem('tcdTableEnWidth', JSON.stringify(tcdTableEnWidth))
          this.tcdTableWidth = JSON.parse(localStorage.tcdTableEnWidth)
        }
          break
        default:
          break
      }
    }

  }

}
</script>
